<template>
    <md-switch v-model.lazy="toggle" v-on:change="toggleGuesser()">Spy Master</md-switch>
</template>

<script>

export default {
  name: 'GuesserToggle',
  data: () => ({
     requesting: false,
     toggle: false
  }),
  computed: {
    isSpyMaster: {
      get() {
        return this.$store.getters.isSpyMaster;
      },
      set(){
        this.toggleGuesser();   
      }
    }
  },
  methods: {
    toggleGuesser(){
      if(this.toggle){
        this.$store.dispatch("releaseSpyMaster");
        this.toggle = this.isSpyMaster;
      } else {
        this.$store.dispatch("requestSpyMaster");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>